import renderingInServer from './renderingInServer';

const localStorageKey = 'truva-vl';
const viewLimit = 3;

export default function useAnonymousViewLimit(
  override: boolean,
  id: string,
): { limitExceeded: boolean } {
  if (renderingInServer()) {
    return { limitExceeded: false };
  }

  if (override) {
    window.localStorage.removeItem(localStorageKey);
    return { limitExceeded: false };
  }

  const rawItems = window.localStorage.getItem(localStorageKey) || '[]';
  const items = JSON.parse(rawItems);

  if (items.includes(id)) {
    // If we've already viewed this item, we're allow to view it again.
    return { limitExceeded: false };
  }

  items.push(id);

  if (items.length > viewLimit) {
    return { limitExceeded: true };
  }

  window.localStorage.setItem(localStorageKey, JSON.stringify(items));

  return { limitExceeded: false };
}
